import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  public isMobile!: boolean;

  constructor() {
    this.isMobile = window.innerWidth <= 768;
  }

  modifyLink(link: string) {
    const utmSource = localStorage.getItem('utm_source');
    if (utmSource) return link + `?utm_source=${utmSource}`;
    return link;
  }

  openSite(url: string, is_utm_source = false) {
    const utmSource = localStorage.getItem('utm_source');
    if (is_utm_source && utmSource) {
      url = url + `?utm_source=${utmSource}`;
    }
    window.open(url);
  }
}
